//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MathTop from '~/components/redesign/math/MathTop'
import VideoSection from '~/components/partner/VideoSection'
import TeacherSection from '~/components/partner/TeacherSection'
import MapSection from '~/components/partner/MapSection'
import QuestionsSection from '~/components/partner/QuestionsSection'
import FeedbackSection from '~/components/partner/FeedbackSection'
import SignupSection from '~/components/partner/SignupSection'

export default {
  name: 'MathPage',
  layout: 'faculty',
  components: {
    MathTop,
    VideoSection,
    TeacherSection,
    MapSection,
    QuestionsSection,
    FeedbackSection,
    SignupSection,
  },
}
